import React from "react";
import { SkeletonBlock, SkeletonLoader } from "@zapier/design-system";

export const ChangePlanSummarySkeleton = () => (
  <SkeletonLoader>
    <SkeletonBlock height="231px" />
  </SkeletonLoader>
);
